import { MetadataFieldConfig } from '../types-v4'

/**
 * Gets metadata for a value based on field mappings
 */
export const getMetadataForValue = (value: string, metadataFields: MetadataFieldConfig[]) => {
  if (!metadataFields?.length || value === undefined || value === null) {
    return {}
  }

  const metadata: Record<string, string> = {}
  metadataFields.forEach((field) => {
    if (field.mapping && field.mapping[value]) {
      metadata[field.property] = field.mapping[value]
    }
  })

  return metadata
}
